import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSessionPermission } from '@btime/react-session'

import { useModalData } from '../../../../components/modals/ModalsContext'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import MinicrudSelect from '../../../../containers/minicruds/select/MinicrudSelect'
import PlaceLevelSelect from '../../../../containers/placeLevels/select/PlaceLevelSelect'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const FormSection = () => {
  const { t } = useTranslation('editLinkTree')
  const modalData = useModalData()
  const isAsset = modalData.data?.entity === 'assets'
  const canConfigureAssetQrCodeMenuRules = useSessionPermission('configureAssetQrCodeMenuRules')
  const showAssetRuleFields = isAsset && canConfigureAssetQrCodeMenuRules

  return (
    <>
      <FormItem label={t('name')} field="name" />
      <Separator weight={2} />
      {!isAsset && (
        <FormItem
          label={t('level')}
          field="placeLevels"
          Input={PlaceLevelSelect}
          types={modalData.placeType}
          multiple
        />
      )}
      {showAssetRuleFields && (
        <>
          <FormItem label={t('assetTypes')} field="assetTypeIds" Input={MinicrudSelect} entity="assetType" multiple />
          <Separator weight={2} />
          <FormItem label={t('assetPlaceLevel')} field="placeLevels" Input={PlaceLevelSelect} multiple />
        </>
      )}
    </>
  )
}

export default FormSection
